import { render, staticRenderFns } from "./basicInfor.vue?vue&type=template&id=6e18b75e&scoped=true"
import script from "./basicInfor.vue?vue&type=script&lang=js"
export * from "./basicInfor.vue?vue&type=script&lang=js"
import style0 from "./basicInfor.vue?vue&type=style&index=0&id=6e18b75e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e18b75e",
  null
  
)

export default component.exports